import { render, staticRenderFns } from "./heroWeb.vue?vue&type=template&id=7efce349&"
import script from "./heroWeb.vue?vue&type=script&lang=js&"
export * from "./heroWeb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports